// extracted by mini-css-extract-plugin
export default {"shiftsTable":"gMoQb0c87YEI4alUgzew","datePickerWrapper":"FcKaTYxd2Ko6P_WShraA","rowNumberColumn":"PGDuIWtCcrMFZSD1mIGy","actionsColumn":"yafpFsA9T5d0MIfaHBi4"};